const ShowSocialOverlay = () => {
  return (document.getElementById("nav-soc-overlay").style.left = "0%");
};

export default ShowSocialOverlay;
